import React from "react";

const CenterCenter = ({ children, style }) => {
  return (
    <div className="deal-center-center" style={style}>
      {children}
    </div>
  );
};

export { CenterCenter };
